import { Component } from '@angular/core';
import { ReportResponseService } from '../../../services/report_response.service';
import { ReportResponseHistoryService } from '../../../services/report_history.service';
import {State} from './state.model'; // Asegúrate de que la ruta sea correcta

@Component({
  selector: 'app-report-history',
  templateUrl: './report-history.component.html',
  styleUrl: './report-history.component.scss'
})
export class ReportHistoryComponent {
  // Variables
  reportHistories: any[] = []; // Cambia el tipo según tu modelo
  currentState: State = {
    _id: '',
    name: '',
    description: ''
  };

  constructor(
        private reportResponseService: ReportResponseService,
        private reportResponseHistoryService: ReportResponseHistoryService

  ){

  }

  ngOnInit(): void {
    this.reportResponseService.selectedReportResponseId$.subscribe(reportResponseId => {
      if (reportResponseId) {
        this.loadReportHistory(reportResponseId);
      }
    });
  }

  loadReportHistory(reportResponseId: string) {
    this.reportResponseHistoryService.getView(reportResponseId).subscribe({
      next: (response: any) => {

        this.reportHistories = response; // Asigna la respuesta a la variable
        this.loadCurrentState(reportResponseId); // Carga el estado actual
        
      },
      error: (err) => {
        console.error('Error obteniendo historial de reportes:', err);
      }
    });
  }

  loadCurrentState(reportResponseId: string) {
    this.reportResponseService.getCurrentState(reportResponseId).subscribe({
      next: (response: any) => {
        this.currentState = response.state; // Asigna la respuesta a la variable
      },
      error: (err) => {
        console.error('Error obteniendo historial de reportes:', err);
      }
    });
  }


}
